import React, { useContext } from 'react';

import cx from 'classnames';
import { prop } from 'ramda';

import EditableText from 'components/shared/EditableText';

import LandingPageContext from '../../contexts/LandingPageContext';
import { useHeadline } from './functions';
import styles from './index.module.css';
import { IHeadlineProps } from './types';

function Headline(props: IHeadlineProps) {
  const { headline, subheadline, mountNodeId, handleHeadlineChange, handleSubheadlineChange, isCenter } =
    useHeadline(props);
  const { readOnly } = useContext(LandingPageContext);

  const { withoutTopBorder } = props;

  return (
    <>
      {headline && (
        <div className={styles.headline}>
          <EditableText
            text={headline}
            placeholder="Headline element"
            onChange={handleHeadlineChange}
            isReadonly={readOnly}
            textAlignment={isCenter ? 'center' : 'left'}
          />
        </div>
      )}

      <div
        className={cx(
          styles.subheadline,
          withoutTopBorder && prop('withoutTopBorder', styles),
          isCenter && prop('subheadlineCenter', styles),
          'custom-right-subheadline',
        )}
      >
        <div className={cx(styles.text, 'custom-right-subheadline-text')}>
          <EditableText
            text={subheadline}
            placeholder="Section Name"
            onChange={handleSubheadlineChange}
            isReadonly={readOnly}
            textAlignment={isCenter ? 'center' : 'left'}
          />
        </div>
        {mountNodeId && <div id={mountNodeId} />}
      </div>
    </>
  );
}

export default Headline;
